import React, { Fragment, useCallback, useMemo } from 'react'

import styles from './AppsTileList.module.css'

import PageLoader from 'Layout/PageLoader'
import AppTile from './AppTile'

import { useGetAllAppsQuery } from '../apps.service'
import appsList from '../appslist'

const TilesList = (props) => {
  const { apps } = props

  return (
    <div className={styles.TilesContainer}>
      {apps.map((tile) => {
        return <AppTile key={tile.viewKey} {...tile} />
      })}
    </div>
  )
}

const AppsTileList = () => {
  const { isFetching, data: installedApps = [] } = useGetAllAppsQuery(null)

  const isConnected = useCallback(
    (appType) => {
      return installedApps.some((app) => app.app_type === appType && app.is_active)
    },
    [installedApps]
  )

  const connectedApps = useMemo(() => {
    return appsList.filter((app) => isConnected(app.app_type))
  }, [isConnected])

  const allApps = useMemo(() => {
    return appsList.filter((app) => !isConnected(app.app_type))
  }, [isConnected])

  if (isFetching) {
    return <PageLoader />
  }

  return (
    <Fragment>
      {installedApps.length > 0 && (
        <div className={styles.ConnectedApps}>
          <p>Connected Apps ({connectedApps.length})</p>
          <TilesList apps={connectedApps} connectedList />
        </div>
      )}
      {allApps.length > 0 && (
        <div className={styles.AllApps}>
          <p>All Apps ({allApps.length})</p>
          <TilesList apps={allApps} />
        </div>
      )}
    </Fragment>
  )
}

export default AppsTileList
